import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Menu/MenuSearchModal/RecommendArea/EmptyState";
import NextImage from "@/src/components/NextImage";

const I18n = I18nUtil.createScoped(Translations);

export const EmptyState = () => (
  <div className="flex flex-col justify-center items-center w-full">
    <NextImage
      src="/assets/images/agent-empty-light.webp"
      alt="empty"
      width={120}
      height={120}
    />
    <span className="body_medium_l text-content_secondary mt-2 mb-1">
      {I18n.t("No Data Yet")}
    </span>
    <span className="body_m text-content_quaternary">
      {I18n.t("No data yet, but exciting updates are on the horizon!")}
    </span>
  </div>
);
